import React from 'react';

import styles from './styles.module.less';

export interface ReportGridProps {
  children: React.ReactNode;
  /** `stack` lays out sections vertically; `twoColumns` places them side by side. */
  layout?: 'stack' | 'twoColumns';
  className?: string;
}

/** Layout container for report summary sections. */
const ReportGrid: React.FC<ReportGridProps> = ({ children, layout = 'stack', className }) => (
  <div className={`${styles[layout]} ${className ?? ''}`}>{children}</div>
);

export default ReportGrid;
